









































import Vue from "vue";
import { state } from "../../data/state";
export default Vue.extend({
  setup() {
    const { selected_severity, set_selected_severity } = state;
    return {
      selected_severity,
      set_selected_severity,
    };
  },
});
